<template>
  <div>
    <template v-if="item.is_preview">
      <silentbox-single :src="item.base64">
        <img class="documents-image-thumb" :src="item.base64" />
      </silentbox-single>
    </template>
    <template v-else>
      <img
        src="/img/document/pdf.png"
        class="documents-image-thumb documents-image-thumb--pdf"
        alt="pdf"
      />
    </template>
  </div>
</template>

<script>
  import SilentboxSingle from 'vue-silentbox/components/single';

  export default {
    components: { SilentboxSingle },
    props: {
      item: {
        type: Object,
        required: true
      }
    }
  };
</script>

<style lang="scss">
  .documents-image-thumb {
    width: 100px;
    height: 100px;
    object-fit: cover;
    padding: 5px;
    &:hover {
      cursor: pointer;
    }
    &--pdf {
      width: 70px;
      height: 70px;
      object-fit: contain;
      &:hover {
        cursor: default;
      }
    }
  }
</style>
